import { getBot } from './public/bot';
import { getAllBots } from './public/bots';
import { getGenerationImagesSettings } from './public/generationImagesSettings';
import { getGenerationVideosSettings } from './public/generationVideosSettings';
import { getGrid, getGridFilters } from './public/grid';
import { getMedia } from './public/media';
import { getSingleMediaPageData } from './public/singleMediaPageData';
export { api } from './client';
export { apiTags } from './names';
export {
	GRID_PER_PAGE,
	SPECIAL_CARD,
	transformGridFilters,
} from './public/grid';
export { prepareMedia, prepareMediaItem } from './public/media';
export { prepareMediaPageData } from './public/singleMediaPageData';

export const publicApi = {
	getBot,
	getAllBots,
	getGrid,
	getGridFilters,
	getMedia,
	getSingleMediaPageData,
	getGenerationImagesSettings,
	getGenerationVideosSettings,
};
